import React from "react";
import { Button, MiniModal, ThemeContext } from "react-ui";
import { CheckCircleCutIcon64Regular } from "@skbkontur/icons";

interface FufAndAttachmentsSuccessProps {
    hasAttachmentErrors?: boolean;
    onClose: () => void;
}

export const FufAndAttachmentsSuccessMiniModal = ({ onClose, hasAttachmentErrors }: FufAndAttachmentsSuccessProps) => {
    const theme = React.useContext(ThemeContext);

    return (
        <MiniModal>
            <MiniModal.Header
                icon={!hasAttachmentErrors ? <CheckCircleCutIcon64Regular color={theme.btnSuccessBg} /> : undefined}>
                Файлы загружены
            </MiniModal.Header>
            {hasAttachmentErrors && <MiniModal.Body>Файлы с ошибками не были добавлены</MiniModal.Body>}
            <MiniModal.Footer>
                <Button size="medium" use="primary" onClick={onClose}>
                    Понятно
                </Button>
            </MiniModal.Footer>
        </MiniModal>
    );
};
